import { useState, useEffect } from "react";

export interface Deliverable {
  id: string;
  name: string;
  websiteUrl?: string;
  file?: {
    id: string;
    url: string;
    filename: string;
    type: string;
    size: number;
  }[];
  type: string;
}

export interface CaseItem {
  id?: string;
  title: string;
  description: string;
  picture?: string;
  video?: string;
  url?: string;
  tag: string;
  category?: string;
  pushToHomepage?: boolean;
  userProvided?: boolean;
  deliverables?: Deliverable[];
}

interface OptionItem {
  label: string;
  value: string;
}

export const useCaseList = () => {
  const [activeCategory, setActiveCategory] = useState<string>("All");
  const [activeTag, setActiveTag] = useState<string>("All");
  const [tagOptions, setTagOptions] = useState<OptionItem[]>([{ label: "All", value: "All" }]);
  const [categoryOptions, setCategoryOptions] = useState<OptionItem[]>([{ label: "All", value: "All" }]);
  const [caseList, setCaseList] = useState<CaseItem[]>([]);
  const [filteredItems, setfilteredItems] = useState<CaseItem[]>([]);
  const [userCaseList, setUserCaseList] = useState<CaseItem[]>([]);
  const [userfilteredItems, setUserfilteredItems] = useState<CaseItem[]>([]);

  // 安全地获取 searchParams
  const getSearchParams = () => {
    try {
      if (typeof window !== "undefined") {
        return new URLSearchParams(window.location.search);
      }
      return new URLSearchParams();
    } catch {
      return new URLSearchParams();
    }
  };

  useEffect(() => {
    //获取路由参数
    const urlParams = getSearchParams();
    const tag = urlParams.get("tag");
    if (tag) {
      setActiveTag(tag);
    }
    const fetchCaseList = async () => {
      try {
        const response = await fetch("/api/use-cases");
        if (!response.ok) {
          throw new Error(`API responded with status: ${response.status}`);
        }
        const data = await response.json();

        console.log(data, "data====");
        if (data && Array.isArray(data.tags)) {
          const newOptions = [{ label: "All", value: "All" }];
          data.tags.forEach((tag: string) => {
            newOptions.push({ label: tag, value: tag });
          });

          setTagOptions(newOptions);
        }
        if (data && Array.isArray(data.categories)) {
          const newOptions = [{ label: "All", value: "All" }];
          data.categories.forEach((category: string) => {
            newOptions.push({ label: category, value: category });
          });
          setCategoryOptions(newOptions);
        }
        if (data && Array.isArray(data.useCases)) {
          // 分离用户提供的case和非用户提供的case
          const userCases: CaseItem[] = [];
          const regularCases: CaseItem[] = [];

          data.useCases.forEach((item: CaseItem) => {
            if (item.userProvided === true) {
              userCases.push(item);
            } else {
              regularCases.push(item);
            }
          });

          setUserCaseList(userCases);
          setCaseList(regularCases);
        }
      } catch (error) {
        console.error("Error case list:", error);
        // 保持使用默认下载列表
      }
    };
    fetchCaseList();
  }, []);

  useEffect(() => {
    const filteredArr = caseList.filter((item) => {
      if (activeTag === "All") {
        return true;
      } else {
        if (item.tag === activeTag) {
          if (activeTag === "Search") {
            if (activeCategory === "All") {
              return true;
            } else {
              if (item.category === activeCategory) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return true;
          }
        }
      }
    });
    setfilteredItems(filteredArr);
  }, [caseList, activeTag, activeCategory]);

  // 添加用户case的过滤逻辑
  useEffect(() => {
    const userFilteredArr = userCaseList.filter((item) => {
      if (activeTag === "All") {
        return true;
      } else {
        if (item.tag === activeTag) {
          if (activeTag === "Search") {
            if (activeCategory === "All") {
              return true;
            } else {
              if (item.category === activeCategory) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return true;
          }
        }
      }
    });
    setUserfilteredItems(userFilteredArr);
  }, [userCaseList, activeTag, activeCategory]);

  useEffect(() => {
    if (activeTag === "Search") {
      setActiveCategory("All");
    }
  }, [activeTag]);

  const getCaseListByTag = (tag: string) => {
    return caseList.filter((item) => {
      return item.tag === tag && item.pushToHomepage;
    });
  };

  const getUserCaseListByTag = (tag: string) => {
    return userCaseList.filter((item) => {
      return item.tag === tag && item.pushToHomepage;
    });
  };

  return {
    activeTag,
    activeCategory,
    tagOptions,
    categoryOptions,
    caseList,
    userCaseList,
    filteredItems,
    userfilteredItems,
    setActiveTag,
    setActiveCategory,
    getCaseListByTag,
    getUserCaseListByTag,
  };
};
